export default class Address {
  static init(config) {
    return new Address(config);
  }

  constructor(config) {
    this.$addressBox = config.container;
    this.$inputElement = config.input;
    this.$actionButton = config.actionButton;
    this.onComplete = config.onComplete || (() => {});
    this.$actionButton.dataset.toggle = 'tooltip';
    this.$actionButton.dataset.title = 'Clique para pesquisar o endereço';

    $(this.$actionButton).on('click', (ev) => {
      ev.preventDefault();
      this.findAddress();
    });
  }

  findAddress() {
    this.$actionButton.classList.remove('address-error');
    this.$actionButton.classList.toggle('address-finding', true);

    let request = $.ajax({
      url: `https://viacep.com.br/ws/${(this.$inputElement.value).replace(/[^0-9]/g, '')}/json`,
      timeout: 3000
    })
    request.done( this.fillElements.bind(this) );
  }

  fillElements(response) {
    this.$actionButton.classList.toggle('address-finding', false);

    if (!!response.erro)
      return this.failToFindAddress();

    this.$actionButton.dataset.title = 'Clique para pesquisar o endereço'

    for (let [key, value] of Object.entries(this.dictionary)) {
      let input = this.$addressBox.querySelector(`[data-address="${key}"]`)

      if (!!input)
        input.value = response[value]
    }

    this.onComplete();
  }

  failToFindAddress() {
    this.$actionButton.classList.add('address-error');
    this.$actionButton.dataset.title = 'CEP inexistente!'
  }

  get dictionary() {
    return {
      "address": "logradouro",
      "neighborhood": "bairro",
      "city": "localidade",
      "state": "uf"
    };
  }
};